/**
 * 공통 이벤트 바 컴포넌트 렌더러
 * - SRP: 이벤트 바의 HTML 구조만 담당
 * - 재사용: 모든 이벤트 타입에서 동일한 디자인 사용
 *
 * @param content 이벤트 바에 표시할 텍스트 내용
 * @param backgroundColor 배경 색상
 * @param borderColor 테두리 색상
 * @param textColor 텍스트 색상
 * @returns HTML 객체
 */
export const renderEventBar = (
  content: string,
  backgroundColor: string,
  borderColor: string,
  textColor: string
) => {
  return {
    html: `
      <div class="fc-event-main-frame" style="
        height: 100%;
        width: 100%;
        background-color: ${backgroundColor}28;
        border: none;
        border-left: 5px solid ${backgroundColor};
        border-radius: 3px;
        margin: 0;
        padding: 2px 6px;
        display: flex;
        align-items: center;
      ">
        <div class="fc-event-title" style="
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #111111;
          width: 100%;
          font-weight: 400;
          letter-spacing: -0.01em;
        ">${content}</div>
      </div>
    `
  };
};
